// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file ai/h2o/audittrail/v1/event_service.proto (package ai.h2o.audittrail.v1, syntax proto3)
/* eslint-disable */

import type { Event } from "./event_pb";
import type { Status } from "../../../../google/rpc/status_pb";
import { RPC } from "../../../../runtime";

/**
 * Request message for `CreateEvent`.
 *
 * @generated from message ai.h2o.audittrail.v1.CreateEventRequest
 */
export type CreateEventRequest = {
/**
 * Required. The ID of the Event resource to create.
 * Must be a UUID4, for example: "b096430b-c7a8-47f2-a129-d9ae58cf454f".
 *
 * @generated from field: string event_id = 1;
 */
eventId: string;
/**
 * Required. The Event resource to create.
 *
 * @generated from field: ai.h2o.audittrail.v1.Event event = 2;
 */
event: Event;
}
;
/**
 * Response message for `CreateEvent`.
 *
 * @generated from message ai.h2o.audittrail.v1.CreateEventResponse
 */
export type CreateEventResponse = {
/**
 * The created Event.
 *
 * @generated from field: ai.h2o.audittrail.v1.Event event = 1;
 */
event?: Event;
}
;
/**
 * Request message.
 *
 * @generated from message ai.h2o.audittrail.v1.BatchCreateEventsRequest
 */
export type BatchCreateEventsRequest = {
/**
 * Required. Events to create.
 * A maximum of 1000 events can be created in a batch.
 *
 * @generated from field: repeated ai.h2o.audittrail.v1.CreateEventRequest requests = 1;
 */
requests: CreateEventRequest[];
}
;
/**
 * Response message.
 *
 * @generated from message ai.h2o.audittrail.v1.BatchCreateEventsResponse
 */
export type BatchCreateEventsResponse = {
/**
 * Created events.
 *
 * @generated from field: repeated ai.h2o.audittrail.v1.Event events = 1;
 */
events?: Event[];
/**
 * Failed CreateEvent requests.
 *
 * The key is the index of the request in the `requests` field of the BatchCreateEventsRequest.
 * The value is the error that would be returned by an individual CreateEvent call for that request.
 *
 * @generated from field: map<int32, google.rpc.Status> failed_requests = 2;
 */
failedRequests?: { [key: number]: Status };
}
;
/**
 * Request message.
 *
 * @generated from message ai.h2o.audittrail.v1.SearchEventsRequest
 */
export type SearchEventsRequest = {
/**
 * Optional. Filter for events.
 * When unset, default filter values will be used.
 *
 * @generated from field: ai.h2o.audittrail.v1.SearchEventsRequest.Filter filter = 1;
 */
filter?: SearchEventsRequest_Filter;
/**
 * Optional. Maximum number of Events to return in a response.
 * When unset, at most 50 Events will be returned.
 * The maximum value is 1000; values above 1000 will be coerced to 1000.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Optional. Leave unset to receive the initial page.
 * To list any subsequent pages, use the value of 'next_page_token'
 * returned from the SearchEventsResponse.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
}
;
/**
 * Filter message encapsulating all filter parameters.
 *
 * @generated from message ai.h2o.audittrail.v1.SearchEventsRequest.Filter
 */
export type SearchEventsRequest_Filter = {
/**
 * Optional. Filter events with event_time >= start_event_time.
 * Defaults to 2025-07-01 00:00:00 +0000 UTC.
 *
 * @generated from field: optional google.protobuf.Timestamp start_event_time = 1;
 */
startEventTime?: string | null;
/**
 * Optional. Filter events with event_time < end_event_time.
 * Defaults to now.
 *
 * @generated from field: optional google.protobuf.Timestamp end_event_time = 2;
 */
endEventTime?: string | null;
/**
 * Optional. Filter events with event_source equal to this value.
 *
 * @generated from field: optional string event_source_exact = 3;
 */
eventSourceExact?: string;
/**
 * Optional. Filter events with event_source matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string event_source_regex = 4;
 */
eventSourceRegex?: string;
/**
 * Optional. Filter events with resource equal to this value.
 *
 * @generated from field: optional string resource_exact = 5;
 */
resourceExact?: string;
/**
 * Optional. Filter events with resource matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string resource_regex = 6;
 */
resourceRegex?: string;
/**
 * Optional. Filter events with read_only equal to this value.
 *
 * @generated from field: optional bool read_only = 7;
 */
readOnly?: boolean;
/**
 * Optional. Filter events with status.code that matches regex from this value.
 * StatusCodes: 0=OK, 1=CANCELLED, 2=UNKNOWN, 3=INVALID_ARGUMENT, ...
 * Filtering events with statusCode OK or INVALID_ARGUMENT can be expressed by regex "^(0|3)$".
 * Filtering events with no statusCode can be expressed by regex "^$".
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string status_code_regex = 8;
 */
statusCodeRegex?: string;
/**
 * Optional. Filter events with principal equal to this value.
 *
 * @generated from field: optional string principal_exact = 9;
 */
principalExact?: string;
/**
 * Optional. Filter events with principal matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string principal_regex = 10;
 */
principalRegex?: string;
/**
 * Optional. Filter events with source_ip_address equal to this value.
 *
 * @generated from field: optional string source_ip_address_exact = 11;
 */
sourceIpAddressExact?: string;
/**
 * Optional. Filter events with source_ip_address matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string source_ip_address_regex = 12;
 */
sourceIpAddressRegex?: string;
/**
 * Optional. Filter events that contain in its metadata the same key-value pairs.
 * For example, if metadata_exact={"a":"b", "c":"d"} then each returned event must contain in its metadata
 * key "a" with value "b" and key "c" with value "d".
 * Empty map implies no filtering by metadata is applied.
 *
 * @generated from field: map<string, string> metadata_exact = 13;
 */
metadataExact?: { [key: string]: string };
/**
 * Optional. Filter events that contain in its metadata keys with values matching a regex.
 * For example, if metadata_regex={"a":".*b.*", "c":".*d.*"} then each returned event must contain in its metadata
 * key "a" with value that "contains letter b" and key "c" with value that "contains letter d".
 * Empty map implies no filtering by metadata is applied.
 * Values must follow Google's RE2 syntax.
 *
 * @generated from field: map<string, string> metadata_regex = 14;
 */
metadataRegex?: { [key: string]: string };
/**
 * Optional. Filter events with workspace equal to this value.
 *
 * @generated from field: optional string workspace_exact = 15;
 */
workspaceExact?: string;
/**
 * Optional. Filter events with workspace matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string workspace_regex = 16;
 */
workspaceRegex?: string;
/**
 * Optional. Filter events with action equal to this value.
 *
 * @generated from field: optional string action_exact = 17;
 */
actionExact?: string;
/**
 * Optional. Filter events with action matching regex from this value.
 * Must follow Google's RE2 syntax.
 *
 * @generated from field: optional string action_regex = 18;
 */
actionRegex?: string;
}
;
/**
 * Response message.
 *
 * @generated from message ai.h2o.audittrail.v1.SearchEventsResponse
 */
export type SearchEventsResponse = {
/**
 * Searched events.
 *
 * @generated from field: repeated ai.h2o.audittrail.v1.Event events = 1;
 */
events?: Event[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
/**
 * The point in time that the backwards search has progressed to.
 *
 * This field is for informational purposes ONLY to indicate search progress.
 * It MUST NOT be used to construct the next search request.
 * Always use the 'next_page_token' for subsequent page requests.
 *
 * Example:
 * For a search from a start_event_time of 'July 1st 00:00:00' to an end_event_time of 'July 10th 00:00:00',
 * the search proceeds backwards from July 10th (exclusive). If this field returns
 * 'July 5th 00:00:00', it means the time range [July 5th, July 10th) has been scanned.
 *
 * @generated from field: google.protobuf.Timestamp searched_until_time = 3;
 */
searchedUntilTime?: string | null;
}
;
/**
 * Creates an Event.
 *
 * @generated from rpc ai.h2o.audittrail.v1.EventService.CreateEvent
 */
export const EventService_CreateEvent = new RPC<CreateEventRequest,CreateEventResponse>("POST", "/v1/events", "event");
/**
 * Create multiple Events in a single transaction.
 *
 * @generated from rpc ai.h2o.audittrail.v1.EventService.BatchCreateEvents
 */
export const EventService_BatchCreateEvents = new RPC<BatchCreateEventsRequest,BatchCreateEventsResponse>("POST", "/v1/events:batchCreate");
/**
 * Searches events.
 *
 * Searching is backwards, ie. you read the latest events
 * and you continue searching via next_page_token to older events.
 *
 * Authorization for this method is dynamic and depends on the filter provided.
 * It uses two permissions:
 *   - **Global Search**: Allows searching across all events.
 *     - Action: "actions/audittrail/events/SEARCH"
 *     - Resource: "//audittrail"
 *
 *   - **Workspace-Scoped Search**: Allows searching within a specific workspace.
 *     - Action: "actions/audittrail/events/SEARCH_WORKSPACE"
 *     - Resource: "//workspaceserver/workspaces/{workspace_id}"
 *
 * The required permission is determined by the filter as follows:
 *   - **For searches not restricted to a single workspace:**
 *     The caller MUST have the **Global Search** permission. This applies when:
 *       - No workspace filter is provided.
 *       - The `workspace_regex` filter is used (e.g., `^workspaces/(w1|w2)$`).
 *
 *   - **For searches within a specific workspace:**
 *     The caller MUST have EITHER the **Global Search** permission OR the
 *     **Workspace-Scoped Search** permission for that specific workspace. This applies when:
 *       - The `workspace_exact` filter is used (e.g., `workspaces/w1`).
 *
 * @generated from rpc ai.h2o.audittrail.v1.EventService.SearchEvents
 */
export const EventService_SearchEvents = new RPC<SearchEventsRequest,SearchEventsResponse>("POST", "/v1/events:search");
